const masthead = document.querySelector('[data-masthead]');

if (masthead) {
  document.querySelector('[data-header-logo]').classList.add('header__logo--small');
}
